/**
 * Whether a property is currently marked for a revisit: flagged, and not
 * resolved since. The flag lives in the feature's attribute bag
 * (revisit_flagged_at / revisit_resolved_at), set from the Field data table.
 */
export function isRevisitActive(properties: Record<string, unknown> | null | undefined): boolean {
  return Boolean(properties?.revisit_flagged_at) && !properties?.revisit_resolved_at;
}
